import * as React from 'react';
import { Link, usePage } from '@inertiajs/react';
import { Flame, ArrowRight } from 'lucide-react';
import { FeaturedProduct } from '../../types/landing';
import { ProductCard } from './ProductCard';
import { route } from '../../utils/route';

interface MostOrderedGridProps {
  products: FeaturedProduct[];
}

export function MostOrderedGrid({
  products,
}: MostOrderedGridProps): React.ReactElement {
  const { defaultCategorySlug } = usePage<{ defaultCategorySlug: string }>().props;
  return (
    <section className="most-ordered-section">
      <style>{`
        .most-ordered-section {
          padding: 40px 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .most-ordered-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
        }

        .most-ordered-title {
          font-size: 24px;
          font-weight: 700;
          color: #333;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .most-ordered-title-icon {
          display: flex;
          align-items: center;
          color: #e8590c;
        }

        .most-ordered-title-short {
          display: none;
        }

        .most-ordered-view-all {
          font-size: 13px;
          font-weight: 600;
          color: #5cb85c;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 8px 16px;
          border: 1.5px solid #5cb85c;
          border-radius: 8px;
          background: transparent;
          transition: all 0.2s;
          white-space: nowrap;
        }

        .most-ordered-view-all:hover {
          background: #5cb85c;
          color: #fff;
          text-decoration: none;
        }

        .most-ordered-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
        }

        .most-ordered-grid .product-card {
          flex: unset;
        }

        @media (max-width: 992px) {
          .most-ordered-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 768px) {
          .most-ordered-section {
            padding: 32px 16px;
          }

          .most-ordered-header {
            margin-bottom: 16px;
          }

          .most-ordered-title {
            font-size: 20px;
          }

          .most-ordered-title-full {
            display: none;
          }

          .most-ordered-title-short {
            display: inline;
          }

          .most-ordered-view-all {
            font-size: 12px;
            padding: 6px 12px;
          }

          .most-ordered-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }

          .most-ordered-grid .product-card {
            flex: unset;
          }
        }
      `}</style>

      <div className="most-ordered-header">
        <h2 className="most-ordered-title">
          <span className="most-ordered-title-icon"><Flame size={24} /></span>
          <span className="most-ordered-title-full">Lo más pedido en Córdoba</span>
          <span className="most-ordered-title-short">Lo más pedido</span>
        </h2>
        <Link href={route('products.index', { cat: defaultCategorySlug })} className="most-ordered-view-all">
          Todos los productos
          <ArrowRight size={16} />
        </Link>
      </div>

      <div className="most-ordered-grid">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
}
